import { Css, Tooltip, useTestIds } from "@homebound/beam";
import { PackageVersionStatus_DesignPackageFragment } from "src/routes/libraries/product-offerings/overview/PackageVersionStatus.generated";

type PackageVersionStatusProps = { version: string; hasUpdates: boolean };

/** A package's version with a dot that is yellow when the package has pending updates and green otherwise. */
export function PackageVersionStatus(props: PackageVersionStatusProps) {
  const { version, hasUpdates } = props;
  const tid = useTestIds(props, "packageVersionStatus");
  return (
    <div css={Css.df.aic.gapPx(6).$}>
      <Tooltip title={hasUpdates ? "Pending updates" : "Up to date"} {...tid}>
        <div css={Css.wPx(8).hPx(8).fs0.br100.if(hasUpdates).bgYellow500.else.bgGreen400.$} />
      </Tooltip>
      <span css={Css.gray700.$}>{version}</span>
    </div>
  );
}

/**
 * A design package can be shared by several plan packages, and `availableUpdates` includes updates from all of them.
 */
export function hasPendingPlanPackageUpdates(
  designPackage: PackageVersionStatus_DesignPackageFragment,
  planPackageId: string,
): boolean {
  return designPackage.availableUpdates.some((u) => u.planVersion.readyPlan.id === planPackageId);
}
